import { formatNumber, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HotelItem } from '@app/models/hotels/HotelItem';
import { VerifyResponse } from '@app/models/offers/VerifyResponse';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TvangebotimagevideoComponent } from '@app/components/modals/tvangebotimagevideo/tvangebotimagevideo.component';
import { MatDialog } from '@angular/material/dialog';
import { MapService } from '@app/services/map.service';
@Component({
    selector: 'clever-pauschal-detail',
    templateUrl: './pauschal-detail.component.html',
    styleUrls: ['./pauschal-detail.component.scss'],
    standalone: false
})
export class PauschalDetailComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() booking: VerifyResponse;
    @Input() hotel: HotelItem;
    @Output() sendAlt: EventEmitter<boolean> = new EventEmitter();
    @Output() sendBook: EventEmitter<boolean> = new EventEmitter();
    private unsubscribe$ = new Subject();

    deskMode: boolean = true;
    showMap: boolean = false;

    transferMessage: string = '';
    zugMessage: string = '';
    mwMessage: string = '';
    spMessage: string = '';
    wlMessage: string = '';
    travelerText: string = '';
    prcdetail: string = '';
    desktopTemplate: string = '';
    map = null;
    curentContent: number = 0;
    categoryAr: number[] = [];

    constructor(
        protected mediaObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog,
        protected mapService: MapService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {

    }

    ngOnInit(): void {
        this.initMedia();
        this.checkService();
        this.initPrcData();
        const catg = Number(String(this.hotel?.category).replace(/,/g, '.').replace(/\+/g, ''));
        for (let i = 0; i < Math.floor(catg); i++) {
            this.categoryAr.push(1);
        }
        if (catg > Math.floor(catg)) {
            this.categoryAr.push(0.5);
        }
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
            this.deskMode = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
            this.deskMode = true;
        }
        this.cdr.detectChanges();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.onMapReady();
        }, 100);
    }

    async initPrcData() {
        let countEr = 1;
        let kind = 0;
        let erw = 0;
        for (let i = 0; i < this.booking?.travellerList?.length; i++) {
            let prc = ''
            if (this.booking.travellerList[i].price?.value?.length > 0) {
                prc = formatNumber(Number(this.booking.travellerList[i].price?.value), 'de-DE', '1.2-2');
            } else {
                if (this.booking.travellerList[i].type === 'H') {
                    prc = formatNumber(Number(this.booking.pricePerPerson?.value), 'de-DE', '1.2-2');
                } else {
                    prc = '?';
                }
            }
            if (prc?.length > 0) {
                if (this.booking.travellerList[i].type === 'H') {
                    this.prcdetail += countEr + '.Erwachsener ' + prc + ' EUR<br>';
                    countEr++;
                    erw += 1;
                } else {
                    this.prcdetail += countEr + '.Kinder ' + prc + ' EUR<br>';
                    countEr++;
                    kind += 1;
                }
            }
        }
        if (erw > 0) {
            this.travelerText = erw + ' Erwachsene';
        }
        if (kind > 0) {
            this.travelerText += ', ' + kind + ' Kinder';
        }
        this.cdr.detectChanges();
    }

    async checkService() {
        if (this.booking?.commonOffer?.transferOffer?.code?.indexOf('MT') >= 0 || this.booking?.commonOffer?.transferOffer?.code?.indexOf('TM') >= 0) {
            this.transferMessage = 'inkl. Transfer';
        }
        if (this.booking?.commonOffer?.serviceOffer?.code?.indexOf('ZG') >= 0) {
            this.zugMessage = 'Zug zum Flug (innerhalb Deutschland)';
        }
        if (this.booking?.commonOffer?.serviceOffer?.code?.indexOf('MW') >= 0) {
            this.mwMessage = 'inkl. Mietwagen';
        }
        if (this.booking?.commonOffer?.serviceOffer?.code?.indexOf('SP') >= 0) {
            const i = this.booking?.commonOffer.serviceOffer.code.indexOf('SP');
            this.spMessage = this.booking?.commonOffer.serviceOffer.description.split(',')?.[i];
        }
        if (this.booking?.commonOffer?.serviceOffer?.code?.indexOf('WL') >= 0) {
            this.wlMessage = 'inkl. Wellnessangebot';
        }
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    sendAalternative() {
        this.sendAlt.emit(true);
    }

    sendBooking() {
        this.sendBook.emit(true);
    }

    initMaps() {
        this.mapService.Leaflet.marker([Number(this.hotel?.location?.latitude), Number(this.hotel?.location?.longitude)],
            {
                icon: this.mapService.Leaflet.icon({
                    iconSize: [25, 41],
                    iconAnchor: [13, 41],
                    iconUrl: 'leaflet/marker-icon.png',
                    shadowUrl: 'leaflet/marker-shadow.png'
                })
            }
        ).bindPopup(this.hotel?.name).addTo(this.map);
        this.map?.invalidateSize();
        this.showMap = true;
        this.cdr.detectChanges();
    }

    onMapReady() {
        if (isPlatformBrowser(this.platformId) && this.hotel?.location?.latitude?.length > 0) {
            this.map = this.mapService.Leaflet.map('map').setView([this.hotel?.location?.latitude, this.hotel?.location?.longitude], 15);
            this.mapService.Leaflet.tileLayer('https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }).addTo(this.map);
            this.map?.invalidateSize();
            this.initMaps();
        }
    }

    async openImageModal(ev) {
        const target = {
            disableClose: true,
            panelClass: ['full-screen-modal'],
            data: {
                hotel: this.hotel,
                images: this.hotel.catalogData.imageList,
                videos: [],
                current: ev,
                to800: true,
                desktopTemplate: this.desktopTemplate
            }
        }
        this.dialog.open(TvangebotimagevideoComponent, target);
    }
}
